export const defaultRegister = () => {
    return {
        email: "",
        password: "",
        passwordConfirmation: "",
        firstName: "",	
        lastName: "",
        company: "",
        city: "",	
        country: "",
        gender: "",
        age: "",

    }
}
export const defaultUser = () => {
    return {
        id: "",
        full_name: "",
        email: "",
    }
}

export const defaultPaymentCredit = () => {
    return {
        number: "",
        expMonth: null,
        expYear: null,
        cvv: null
    }
}


export const defaulNewPassword = () => {
    return {
        password: "",
        passwordConfirmation: "",
    }
}
export const defaulChangePassword = () => {
    return {
        oldPassword: "",
        password: "",
        passwordConfirmation: "",
    }
}
export const defaulDeleteAccount = () => {
    return {
        password: ""
    }
}

export const defaulLostPassword = () => {
    return {
        email: '',
        grantType: 'password',
    }
}
export default {
    register: defaultRegister(),
    user: defaultUser(),
    loginUser: {
        email: '',
        password: '',
        grantType: 'password',
    },
    paymentMethod: [],
    origin: window.location.href,
    paymentData: defaultPaymentCredit(),
    changePassword: defaulChangePassword(),
    deleteAccount: defaulDeleteAccount(),
    magAssets: [],
    accessFee: null,
    accessAssets:[],
    assetVal:[],
    pay: false,
    forgot: {
        email: "",
    },
    token: "",
    change: defaulNewPassword(),
    customerID: ""


}